import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { LanguageSelectComponent } from './components/language-select/language-select.component';
import { LanguageMaterialModules } from './language.module.material';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './../../../assets/i18n/', '.json');
}

@NgModule({
  declarations: [LanguageSelectComponent],
  imports: [
    CommonModule,
    LanguageMaterialModules,
    HttpClientModule,
    TranslateModule.forChild({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
  ],
  exports: [TranslateModule, LanguageSelectComponent],
})
export class LanguageModule {
  static forRoot(): ModuleWithProviders<LanguageModule> {
    return {
      ngModule: LanguageModule,
    };
  }
}
